<template>
  <div id="app" class="h-full w-full bg-main font-main">
    <div class="w-full h-full bg-main overflow-hidden">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </div>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useAppStore } from "@/app-store/app";

export default {
  methods: {
    ...mapActions(useAppStore, ["getAppInfo"]),
  },
};
</script>
